import { render, staticRenderFns } from "./StandardEditorPage.vue?vue&type=template&id=19f2c766&scoped=true"
import script from "./StandardEditorPage.vue?vue&type=script&lang=js"
export * from "./StandardEditorPage.vue?vue&type=script&lang=js"
import style0 from "./StandardEditorPage.vue?vue&type=style&index=0&id=19f2c766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f2c766",
  null
  
)

export default component.exports